// extracted by mini-css-extract-plugin
module.exports = {"logoImg":"Header_logoImg__kyvHD"};